// created by dubinbin 2018.9.17
// 首页feed流列表卡片

import React from 'react'
import {WKTag} from '../wk'

class MainItemListCardView extends React.Component{
    constructor(props){
        super(props)
    }

    renderLectureTag() {
        const lecture = this.props.content;
        if (lecture.lecture_mode === 'default'){
            switch (lecture.image_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }else {
            switch (lecture.lecture_mode) {
                case 'video':
                    return <WKTag text={'视频'}/>;
                case 'audio':
                    return <WKTag text={'音频'}/>;
                default:
                    return true
            }
        }
    }

    renderTag(){
        const {content} = this.props;
        const youxuanStyle = {
            top: 2,
            position: 'relative',
            marginRight: 7,
            width: 35,
            display: 'inline-block',
        }
        if(content.is_preffered){
            return(
                <div style={youxuanStyle}>
                    <img src={require('../../images/youxuan@3x.png')} alt=""/>
                </div>
            )
        }
        if(content.type && content.type === 'lecture' && !content.is_preffered){
            this.renderLectureTag()
            if (content.image_mode === 'ppt' && content.lecture_mode === 'default'){
                return <WKTag text={'PPT'}/>;
            }
        }
    }

    //左下"已更新xx"等信息的判断显示
    showLeftBottomInfo(){
        const lecture = this.props.content;

        if(lecture.lecture_mode==='video' || lecture.lecture_mode==='audio'){
            return (
                <p>时长<span>{lecture.audio_length}</span>分钟</p>
            )
        }


        if(lecture.type && lecture.type==='channel'){
            return (
                <p>已更新<span>{lecture.current_status_display.replace('已更新', '').replace('期', '').replace('节课程', '').replace('含', '')}</span>期</p>
            )
        }

        if (lecture.status === 'closed'){
            if (lecture.audio_length <= 5){
                return (
                    <p>{lecture.start_time.split(' ')[0]}</p>
                )
            }else {
                return (
                    <p>时长<span>{lecture.audio_length}</span>分钟</p>
                )
            }
        }else {
            return (
                <p>{lecture.status_name}</p>
            )
        }
    }

    renderPrice(){
        const {content} = this.props
        if (content.need_money){
            if (content.has_limitmoney){
                if (Number(content.limit_money) === 0 || content.limit_money===''){
                    return <span>限时免费</span>
                }else {
                    return <p><i>￥</i>{content.limit_money.split('.')[0]}<span style={{fontSize: 10}}>.{content.limit_money.split('.')[1]}</span></p>
                }
            }else {
                return <p><i>￥</i>{content.lecture_money.split('.')[0]}<span style={{fontSize: 10}}>.{content.lecture_money.split('.')[1]}</span></p>
            }
        }else {
            return <span style={{fontWeight:'500'}}>免费</span>
        }
    }

    clickItemsHandle(url){
        window.location.href = url
    }

    render(){
        const { content } = this.props
        if(!content){
            return null
        }

        return(
            <div className="cardView-wrap">
                <div className="cardView-item" onClick={() => this.clickItemsHandle(content.url)} key={content.id}>
                    <div className="cover" style={{backgroundImage : `url(${content.cover_url ? content.cover_url : content.cover })`}}></div>
                    <div className="content-area">
                        <div className="title_area">
                            <div className="tags">
                                {this.renderTag()}
                            </div>
                                {content.name}
                       </div>
                        <div className="price-area">
                            <div className="real-price">
                                {this.renderPrice()}
                            </div>
                            {content.has_limitmoney && Number(content.limit_money) > 0 && content.stype !== 'coupon' &&
                                <div className="origin-price">
                                    ¥{content.lecture_money}
                                </div>
                            }
                        </div>
                        <div className="cardView-bottom">
                            <div className="item-status">
                                {this.showLeftBottomInfo()}
                            </div>

                            <div className="study-num">
                                <span>{content.popular >= 10000 ? (content.popular / 10000).toFixed(2) + '万' : content.popular}</span>人在学
                            </div>
                        </div>
                 </div>
                </div>
            </div>
        )
    }
}

export default MainItemListCardView


// WEBPACK FOOTER //
// ./src/components/main/MainItemListCardView.js